import styled, { css } from 'styled-components';

import { Button } from '@xing-com/button';
import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { ListItem } from '@xing-com/list';
import { ProgressBar } from '@xing-com/progress-bar';
import {
  scale130,
  spaceM,
  spaceS,
  xdlColorText,
  xdlColorBackgroundTertiary,
  scale190,
} from '@xing-com/tokens';
import { BodyCopy, Meta } from '@xing-com/typography';

export const StyledListItem = styled(ListItem)<{ $isSelected: boolean }>`
  /* TODO: discuss with UX about the clickable area of the radio button (label, mobile / desktop) */
  align-items: normal;
  justify-content: flex-start;
  gap: ${spaceM};
  min-height: ${scale190};

  ${(props) => css`
    ${props.$isSelected &&
    css`
      background-color: ${xdlColorBackgroundTertiary};
    `};
  `};
`;

//TODO: discuss with UX about the clickable area of the radio button (label, mobile / desktop)
export const RadioButtonContainer = styled.span`
  align-items: center;
  display: inline-flex;
`;

export const DownloadLink = styled.a<{ $isEmptyLink: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${spaceM};
  width: 100%;
  color: ${xdlColorText};
  text-decoration: none;

  ${(props) => css`
    ${props.$isEmptyLink &&
    css`
      &:hover {
        text-decoration: none;
      }
    `};
  `};
`;

export const StyledProgressBar = styled(ProgressBar)`
  padding: ${spaceM} 0 0;
  width: 100%;
`;

export const TextContentWrapper = styled.div`
  overflow-wrap: break-word;
`;

export const FileNameBodyCopy = styled(BodyCopy)`
  word-break: break-word;
  ${lineClamp(2)}
`;

export const NoCvBodyCopy = styled(BodyCopy)`
  display: inline-flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  height: ${scale130};
  min-width: ${scale130};
  width: ${scale130};
`;

export const DeleteButton = styled(Button)`
  height: auto;
`;

export const StyledMeta = styled(Meta)`
  margin: 0;
  && {
    color: ${xdlColorText};
  }
  span {
    &:not(:first-child) {
      margin-left: ${spaceS};
    }
  }
`;
